import apiClient from "../api/apiClient";
import { ENDPOINTS } from "../api/endPoints";
import { createRegisterFormData } from "../models/userModel";

export const getUserDetails = async (userId) => {
  try {
    const url = ENDPOINTS.GET_USER_DETAILS(userId);
    const response = await apiClient.get(url);

    console.log("Status code:", response.status);
    console.log("Response data:", response.data);

    return response.data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};

export const updateFcmToken = async (userId, fcmToken) => {
  const formData = new FormData();
  formData.append("fcm_token", fcmToken);

  const response = await apiClient.put(
    `/user/update-user-byId/${userId}`,
    formData,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};

export const updateUser = async (userId, rawUserData, fcmToken) => {
  let stage = "Preparing profile details";
  try {
    if (userId == null || String(userId).trim() === "") {
      throw new Error("Your user ID is missing. Please sign in again.");
    }
    // Pass 'true' to isUpdate flag to bypass image appending in userModel
    const payload = createRegisterFormData(rawUserData, fcmToken, true);

    // const isOldUser =
    //   rawUserData.is_old_user !== undefined
    //     ? rawUserData.is_old_user
    //     : rawUserData.isOldUser !== undefined
    //       ? rawUserData.isOldUser
    //       : 1;
    // payload.append("is_old_user", isOldUser ? 1 : 0);

    // explicitly strip images to guarantee they aren't sent to update-user-byId
    payload.delete("images");
    payload.delete("image_index");

    stage = "Saving profile details";
    const response = await apiClient.put(
      `/user/update-user-byId/${userId}`,
      payload,
    );

    // Handle image updates exclusively with the update-user-images-by-index API
    const imageFormData = new FormData();
    const changedIndexes = [];

    if (rawUserData.photos) {
      const photoMap = [
        { key: "main", index: 0 },
        { key: "sub1", index: 1 },
        { key: "sub2", index: 2 },
        { key: "sub3", index: 3 },
      ];

      photoMap.forEach(({ key, index }) => {
        if (rawUserData.photos[key] instanceof File) {
          imageFormData.append("user_profile_image", rawUserData.photos[key]);
          changedIndexes.push(index);
        }
      });
    }

    if (changedIndexes.length > 0) {
      stage = "Profile details saved, but uploading photos";
      imageFormData.append("indexes", JSON.stringify(changedIndexes));
      await apiClient.put(
        `/user/update-user-images-by-index/${userId}`,
        imageFormData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
    }

    return response.data;
  } catch (error) {
    const body = error.response?.data;
    const reason = [body?.data, body?.message, body?.error, error.message]
      .find((value) => typeof value === "string" && value.trim());
    const status = error.response?.status;
    const message = `${stage} failed${status ? ` (HTTP ${status})` : ""}: ${reason || "Please try again."}`;
    console.error("User update failed:", { stage, status, message });
    throw new Error(message);
  }
};
